module.exports = __webpack_public_path__ + "img/upgrade-colse.fe0973c9.svg";